import { render, staticRenderFns } from "./FormForm.vue?vue&type=template&id=3bf51382&scoped=true&"
import script from "./FormForm.vue?vue&type=script&lang=js&"
export * from "./FormForm.vue?vue&type=script&lang=js&"
import style0 from "./FormForm.vue?vue&type=style&index=0&id=3bf51382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf51382",
  null
  
)

export default component.exports